import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import TableElementModifyPreviewModal from "./modals/TableElementModifyPreviewModal";
import { displayNotification } from "helpers";
import { FaPencilAlt, FaTrash } from "react-icons/fa";
import DropdownMenu from "../DropdownMenu";
import { uniqueId } from "lodash";

const TableBodyPreview = (props) => {
    const editModalRefs = useRef([]);

    const [refresh, setRefresh] = useState(0);

    const handleChangeInLocalStorage = () => {
        setRefresh(uniqueId());
    };

    useEffect(() => {
        window.addEventListener("pvsa-table-element-change", handleChangeInLocalStorage);
        return () => {
            window.removeEventListener("pvsa-table-element-change", handleChangeInLocalStorage);
        };
    }, []);

    const previewData = useMemo(() => {
        try {
            const check = localStorage.getItem(`pvsa_${props.templateId}_table_data_${props.tableId}`);
            if (check === null) {
                localStorage.setItem(`pvsa_${props.templateId}_table_data_${props.tableId}`, JSON.stringify([]));
                return [];
            } else {
                return JSON.parse(check);
            }
        } catch (e) {
            console.error({ error: e });
            displayNotification("error", "Error loading table data [F]");
            return [];
        }
    }, [props.tableId, props.templateId, refresh]);

    const handleDelete = useCallback(
        (id) => {
            try {
                if (window.confirm("You are about to delete a row. Are you sure?")) {
                    let check = localStorage.getItem(`pvsa_${props.templateId}_table_data_${props.tableId}`);
                    if (check === null) {
                        displayNotification("error", "Error deleting invalid table row");
                        return;
                    }
                    check = JSON.parse(check);
                    delete check[id];
                    localStorage.setItem(
                        `pvsa_${props.templateId}_table_data_${props.tableId}`,
                        JSON.stringify(check.filter((r) => r))
                    );
                    displayNotification("success", "Successfully deleted table row");
                    window.dispatchEvent(new Event("pvsa-table-element-change"));
                }
            } catch (e) {
                console.error({ e });
                displayNotification("error", "Error delete table row");
            }
        },
        [props.tableId, props.templateId]
    );

    return (
        <>
            {previewData.length > 0 ? (
                previewData.map((rs, ks) => (
                    <tr key={ks}>
                        <td className="text-center">{ks + 1}</td>
                        {Object.values(rs).map((r, k) => (
                            <td key={k}>{r}</td>
                        ))}
                        {props.isReadOnly === false && (
                            <td>
                                <DropdownMenu
                                    sx={{
                                        zIndex: 9999999999
                                    }}
                                    items={[
                                        {
                                            icon: <FaPencilAlt />,
                                            text: "Edit",
                                            onClick: () => editModalRefs.current[ks].openModal(),
                                        },
                                        {
                                            icon: <FaTrash />,
                                            text: "Delete",
                                            onClick: () => handleDelete(ks),
                                        },
                                    ]}
                                />
                                <TableElementModifyPreviewModal
                                    ref={(ref) => (editModalRefs.current[ks] = ref)}
                                    mode="edit"
                                    display="none"
                                    id={ks}
                                    templateId={props.templateId}
                                    tableId={props.tableId}
                                    columns={props.columns}
                                />
                            </td>
                        )}
                    </tr>
                ))
            ) : (
                <tr>
                    <td className="text-center" colSpan={props.columns.length + 2}>
                        No Data Found
                    </td>
                </tr>
            )}
        </>
    );
};

TableBodyPreview.defaultProps = {
    templateId: "",
    tableId: "",
    columnsCount: 0,
    columns: 0,
    isReadOnly: false,
};

export default TableBodyPreview;
